import { apiService } from '../../services/api';
import type { FilterOption } from './listFilters';

/** Record pickers for filters ("entity" fields): name search → { value: id, label: name }. */
export const searchVendors = async (q: string): Promise<FilterOption[]> => {
  const res = await apiService.getVendors({ search: q || undefined, limit: 12, sortBy: 'name', sortOrder: 'asc' });
  return (res.data?.vendors || []).map((v: any) => ({ value: String(v._id), label: v.name }));
};

export const searchProducts = async (q: string): Promise<FilterOption[]> => {
  const res = await apiService.getProductsByCatalogue('default', { search: q || undefined, limit: 12, sortBy: 'name', sortOrder: 'asc' });
  return (res.data?.products || []).map((p: any) => ({ value: String(p._id), label: p.sku ? `${p.name} · ${p.sku}` : p.name }));
};

export const searchCategories = async (q: string): Promise<FilterOption[]> => {
  const res: any = await apiService.getCatalogues({ search: q || undefined, limit: 12, sortBy: 'name', sortOrder: 'asc' } as any);
  const list = res.data?.catalogues || res.data || [];
  return (Array.isArray(list) ? list : []).map((c: any) => ({ value: String(c._id), label: c.name }));
};
